var path = '/modules/contacts/components/al-contact-selector/component.tpl.html';
var html = "<div class=\"al-rsvp-selector\">\n    <div class=\"form-group input-full\">\n        <label>Contact</label>\n        <al-selectize items=\"vm.items.contacts\"\n                      model=\"vm.models.contact_id\"\n                      disabled=\"vm.disabledStates.contacts\"\n                      selectize-options=\"vm.selectizeOptions.contacts\"\n                      on-change=\"vm.handleContactChange(value)\"></al-selectize>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/components/al-contact-selector/component.tpl.html
// module id = 2068
// module chunks = 1